'use strict';

import angular from 'angular';

/**
 * Configuration des routes pour la section des contrats pétroliers
 */
export default angular.module('observatoireApp')
  .config(['$stateProvider', function($stateProvider) {
    $stateProvider
      .state('main.contrats-petroliers', {
        url: '/contrats-petroliers',
        templateUrl: 'app/contrats-petroliers/contrats-petroliers.html',
        controller: 'ContratsPetroliersController'
      });
  }]);
